// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
// Sibling imports
const TopCallToActionExplainer = require('./explainer')

const bem = BemEntity('TopCallToActionExperimentCSplitLeading')

function TopCallToActionExperimentCSplitLeading(props) {
  return tag('div', {
    ref: props.forwardedRef,
    className: classNames(
      bem.block(),
      props.className
    )
  },
    tag('div', {
      className: bem.element('logo-lockup')
    },
      tag('div', {
        className: bem.element('logo-icon')
      }),
      tag('div', {
        className: bem.element('logo-text')
      })
    ),
    tag(TopCallToActionExplainer, {
      className: bem.element('explainer')
    })
  )
}

module.exports = TopCallToActionExperimentCSplitLeading
